import React, { useState, useEffect, useCallback } from 'react';
import './GravurfarbenverwaltungComponent.css';
import {
  getRohlingfarben,
  createRohlingfarbe,
  updateRohlingfarbe,
  deleteRohlingfarbe
} from '../services/api';

function RohlingfarbenVerwaltung() {
  const [farben, setFarben] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    hexColor: '#cccccc'
  });

  const loadFarben = useCallback(async () => {
    try {
      const data = await getRohlingfarben();
      setFarben(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Fehler beim Laden der Rohling-Farben:', error);
      setFarben([]);
    }
  }, []);

  useEffect(() => {
    loadFarben();
  }, [loadFarben]);

  const resetForm = () => {
    setFormData({
      name: '',
      hexColor: '#cccccc'
    });
    setEditId(null);
    setShowForm(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editId) {
        await updateRohlingfarbe(editId, formData);
      } else {
        await createRohlingfarbe(formData);
      }
      await loadFarben();
      resetForm();
      alert(editId ? 'Rohling-Farbe aktualisiert!' : 'Rohling-Farbe hinzugefügt!');
    } catch (error) {
      console.error('Fehler beim Speichern der Rohling-Farbe:', error);
      const msg = error?.response?.data?.error || 'Fehler beim Speichern';
      alert(msg);
    }
  };

  const handleEdit = (farbe) => {
    setEditId(farbe.id);
    setFormData({
      name: farbe.name,
      hexColor: farbe.hexColor
    });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Diese Rohling-Farbe wirklich löschen?')) return;
    try {
      await deleteRohlingfarbe(id);
      await loadFarben();
      alert('Rohling-Farbe gelöscht!');
    } catch (error) {
      console.error('Fehler beim Löschen:', error);
      const msg = error?.response?.data?.error || 'Fehler beim Löschen';
      alert(msg);
    }
  };

  return (
    <div className="gravurfarben-verwaltung">
      <div className="header-actions">
        <h2>Rohling-Farben verwalten</h2>
        <button className="btn btn-primary" onClick={() => setShowForm(!showForm)}>
          {showForm ? 'Abbrechen' : 'Neue Rohling-Farbe'}
        </button>
      </div>

      {showForm && (
        <div className="card form-card">
          <h3>{editId ? 'Rohling-Farbe bearbeiten' : 'Neue Rohling-Farbe'}</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="rf-name">Name *</label>
              <input
                id="rf-name"
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
                placeholder="z.B. Gold, Silber, Rot"
              />
            </div>
            <div className="form-group">
              <label htmlFor="rf-hex">Farbe *</label>
              <div className="color-picker-group">
                <input
                  id="rf-hex"
                  type="color"
                  value={formData.hexColor}
                  onChange={(e) => setFormData({ ...formData, hexColor: e.target.value })}
                  required
                />
                <input
                  type="text"
                  value={formData.hexColor}
                  onChange={(e) => setFormData({ ...formData, hexColor: e.target.value })}
                  placeholder="#cccccc"
                  pattern="^#[0-9A-Fa-f]{6}$"
                  title="Hex-Farbcode (z.B. #FF00AA)"
                  required
                />
              </div>
            </div>
            <div className="form-actions">
              <button type="submit" className="btn btn-success">
                {editId ? 'Aktualisieren' : 'Hinzufügen'}
              </button>
              <button type="button" className="btn btn-secondary" onClick={resetForm}>
                Abbrechen
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="gravurfarben-list">
        {farben.length === 0 ? (
          <p>Keine Rohling-Farben vorhanden. Fügen Sie eine neue hinzu.</p>
        ) : (
          farben.map(farbe => (
            <div key={farbe.id} className="gravurfarbe-card">
              <div className="gravurfarbe-preview">
                <div
                  className="color-circle"
                  style={{ backgroundColor: farbe.hexColor }}
                  title={farbe.hexColor}
                />
              </div>
              <div className="gravurfarbe-info">
                <h3>{farbe.name}</h3>
                <p className="color-code">{farbe.hexColor}</p>
              </div>
              <div className="gravurfarbe-actions">
                <button className="btn btn-secondary btn-sm" onClick={() => handleEdit(farbe)}>
                  Bearbeiten
                </button>
                <button className="btn btn-danger btn-sm" onClick={() => handleDelete(farbe.id)}>
                  Löschen
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default RohlingfarbenVerwaltung;
